import { Region } from '@/types'

// DEV
export const NEW_STORES_DEV = [
  'Summerville',
  'Rolling Meadows',
  'Red Fork',
  'Brookhaven West',
]

export const NEW_STORES_DEV_JOINED = [
  'Summerville',
  'Rolling Meadows',
  'Red Fork',
  'Brookhaven West',
].join(',')

export const SAME_STORES_DEV = [
  'Kingsbury',
  'Pine Bluff',
  'Silverbrook',
  'Vista',
  'Haverhill',
  'Franklin-Ridge',
  'Harrington',
  'Ashburn',
]

export const SAME_STORES_DEV_JOINED = [
  'Kingsbury',
  'Pine Bluff',
  'Silverbrook',
  'Vista',
  'Haverhill',
  'Franklin-Ridge',
  'Harrington',
  'Ashburn',
].join(',')

/**
 * Get all DEV stores from sessionStorage
 * Uses sessionStorage to avoid circular dependency with Redux
 */
export const ALL_STORES_DEV_JOINED = (includeOther = false): string => {
  const storedRegions = sessionStorage.getItem('regions')
  if (!storedRegions) return SAME_STORES_DEV_JOINED

  try {
    const regions = JSON.parse(storedRegions) as Region[]
    const filteredRegions = includeOther
      ? regions
      : regions.filter((region) => region.name !== 'Other')
    const allBranches = filteredRegions.flatMap((region) => region.branches)
    return allBranches.map((branch) => branch.name).join(',')
  } catch (error) {
    console.error('Failed to parse regions from sessionStorage', error)
    return SAME_STORES_DEV_JOINED
  }
}

// BLANKSTREET
export const NEW_STORES_BLANKSTREET = ['Woodbury']

export const NEW_STORES_BLANKSTREET_JOINED = ['Woodbury'].join(',')

export const SAME_STORES_BLANKSTREET = [
  'McCarren Parkhouse',
  'Blankstreet Regulars New York',
  'William & Fulton',
]

export const SAME_STORES_BLANKSTREET_JOINED = [
  'McCarren Parkhouse',
  'Blankstreet Regulars New York',
  'William & Fulton',
].join(',')

/**
 * Get all BLANKSTREET stores from sessionStorage
 * Uses sessionStorage to avoid circular dependency with Redux
 */
export const ALL_STORES_BLANKSTREET_JOINED = (includeOther = false): string => {
  const storedRegions = sessionStorage.getItem('regions')
  if (!storedRegions) return SAME_STORES_BLANKSTREET_JOINED

  try {
    const regions = JSON.parse(storedRegions) as Region[]
    const filteredRegions = includeOther
      ? regions
      : regions.filter((region) => region.name !== 'Other')
    const allBranches = filteredRegions.flatMap((region) => region.branches)
    return allBranches.map((branch) => branch.name).join(',')
  } catch (error) {
    console.error('Failed to parse regions from sessionStorage', error)
    return SAME_STORES_BLANKSTREET_JOINED
  }
}
